export const TIME_BLOCK_TAB_CHANGED = 'time_block_tab_changed';
export const TIME_BLOCK_PAGE_INFO_CLICKED = 'time_block_page_info_clicked';
export const TIME_BLOCK_DELETE_CLICKED = 'time_block_delete_clicked';
export const TIME_BLOCK_NEW_BLOCK_CLICKED = 'time_block_new_block_clicked';
